export default {"src":"/_next/static/media/WM.d2ec7a52.svg","height":18,"width":18};